import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllUsers } from '@actions/users/fetchAllUsers';
import { getUserPostSuccess } from '@selectors/users';
import usePrevious from 'lib/src/hooks/usePrevious';

const useUsersFetch = (): void => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchAllUsers());
    }, [dispatch]);

    const postSuccess = useSelector(getUserPostSuccess);
    const prevSuccess = usePrevious(postSuccess);

    useEffect(() => {
        if (postSuccess && !prevSuccess) dispatch(fetchAllUsers());
    }, [postSuccess, prevSuccess, dispatch]);
};

export default useUsersFetch;
